import './MessageBoxPage.scss';

import { b2x } from '@b2x/react/src';
import classnames from 'classnames';

import { Page } from './Page';
export interface MessageBoxPageProps {
  alignItems:
    | 'align-items-start'
    | 'align-items-end'
    | 'align-items-center'
    | 'align-items-baseline'
    | 'align-items-stretch';
  asset?: b2x.contentTypes.AssetAsBackgroundContentSectionV2;
  children: React.ReactNode;
  justifyContent:
    | 'justify-content-start'
    | 'justify-content-end'
    | 'justify-content-center'
    | 'justify-content-between'
    | 'justify-content-around'
    | 'justify-content-evenly';
}

export const MessageBoxPage = ({ alignItems, asset, children, justifyContent }: MessageBoxPageProps) => {
  return (
    <Page backgroundAsset={asset} backgroundSize="cover" className="message-box-page" noPaddingBottom noPaddingTop>
      <div className={classnames('message-box-content d-flex ', alignItems, 'h-100')}>
        <div className="container-lg">
          <div className={classnames('row', justifyContent)}>
            <div className="col-12 col-lg-6 col-xl-5">
              <div className="text-container text-center my-5">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};
